<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select v-model="listQuery.tenantId" placeholder="租户" clearable style="width: 200px" class="filter-item">
        <el-option v-for="tenant in tenantList" :key="tenant.tenantId" :label="tenant.name" :value="tenant.tenantId" />
      </el-select>
      <el-input v-model="listQuery.agentName" placeholder="客服名称" clearable style="width: 200px;" class="filter-item" @keyup.enter.native="handleFilter" />
      <el-select v-model="listQuery.status" placeholder="状态" clearable style="width: 150px" class="filter-item">
        <el-option label="在线" value="online" />
        <el-option label="离线" value="offline" />
        <el-option label="忙碌" value="busy" />
      </el-select>
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">搜索</el-button>
      <el-button class="filter-item" style="margin-left: 10px;" type="success" icon="el-icon-plus" @click="handleCreate">新增</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%;">
      <el-table-column label="ID" prop="agentId" align="center" width="80" />
      <el-table-column label="客服编号" prop="agentNo" align="center" width="120" />
      <el-table-column label="所属租户" align="center" width="200">
        <template slot-scope="{row}">
          {{ row.tenantNo ? row.tenantNo + ' - ' : '' }}{{ row.tenantName }}
        </template>
      </el-table-column>
      <el-table-column label="登录账号" prop="loginCode" align="center" width="120" />
      <el-table-column label="密码" prop="password" align="center" width="120" />
      <el-table-column label="客服名称" prop="agentName" align="center" />
      <el-table-column label="显示名称" prop="displayName" align="center" />
      <el-table-column label="头像" align="center" width="70">
        <template slot-scope="{row}">
          <el-avatar :size="40" :src="row.avatarUrl" icon="el-icon-user-solid"></el-avatar>
        </template>
      </el-table-column>
      <el-table-column label="部门" prop="departmentName" align="center" />
      <el-table-column label="状态" prop="status" align="center" width="100">
        <template slot-scope="{row}">
          <el-tag :type="row.status | statusFilter">{{ row.status }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="当前会话" prop="currentConversationCount" align="center" width="100" />
      <el-table-column label="最大并发" prop="maxConcurrent" align="center" width="100" />
      <el-table-column label="操作" align="center" width="250">
        <template slot-scope="{row}">
          <el-button type="primary" size="mini" @click="handleUpdate(row)">编辑</el-button>
          <el-button type="warning" size="mini" @click="handleResetPassword(row)">重置密码</el-button>
          <el-button type="danger" size="mini" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize" @pagination="getList" />

    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="100px" style="width: 400px; margin-left:50px;">
        <el-form-item label="所属租户" prop="tenantId">
          <el-select v-model="temp.tenantId" placeholder="请选择租户" style="width: 100%" @change="handleTenantChange" :disabled="dialogStatus === 'update'">
            <el-option v-for="tenant in tenantList" :key="tenant.tenantId" :label="tenant.name" :value="tenant.tenantId" />
          </el-select>
        </el-form-item>
        <el-form-item label="部门" prop="departmentId">
          <el-select v-model="temp.departmentId" placeholder="请选择部门" style="width: 100%" clearable>
            <el-option v-for="dept in departmentList" :key="dept.departmentId" :label="dept.name" :value="dept.departmentId" />
          </el-select>
        </el-form-item>
        <el-form-item label="登录账号" prop="loginCode">
          <el-input v-model="temp.loginCode" />
        </el-form-item>
        <el-form-item label="客服名称" prop="agentName">
          <el-input v-model="temp.agentName" />
        </el-form-item>
        <el-form-item label="显示名称" prop="displayName">
          <el-input v-model="temp.displayName" />
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="temp.email" />
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input v-model="temp.phone" />
        </el-form-item>
        <el-form-item label="角色" prop="role">
          <el-select v-model="temp.role" placeholder="请选择角色">
            <el-option label="普通客服" value="agent" />
            <el-option label="客服主管" value="supervisor" />
          </el-select>
        </el-form-item>
        <el-form-item label="最大并发数" prop="maxConcurrent">
          <el-input-number v-model="temp.maxConcurrent" :min="1" :max="100" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="dialogStatus==='create'?createData():updateData()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listAgents, createAgent, updateAgent, deleteAgent, resetAgentPassword } from '@/api/agent'
import { listTenants } from '@/api/tenant'
import { listDepartments } from '@/api/department'
import Pagination from '@/components/Pagination'

export default {
  name: 'AgentList',
  components: { Pagination },
  filters: {
    statusFilter(status) {
      const statusMap = {
        online: 'success',
        offline: 'info',
        busy: 'warning'
      }
      return statusMap[status]
    }
  },
  data() {
    return {
      list: null,
      total: 0,
      listLoading: true,
      tenantList: [],
      departmentList: [],
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        tenantId: undefined,
        agentName: undefined,
        status: undefined
      },
      temp: {},
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '创建'
      },
      rules: {
        tenantId: [{ required: true, message: '请选择租户', trigger: 'change' }],
        loginCode: [{ required: true, message: '请输入登录账号', trigger: 'change' }],
        agentName: [{ required: true, message: '请输入客服名称', trigger: 'change' }]
      }
    }
  },
  created() {
    this.getList()
    this.getTenantList()
  },
  methods: {
    getList() {
      this.listLoading = true
      listAgents(this.listQuery).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.listLoading = false
      })
    },
    getTenantList() {
      listTenants({ pageNum: 1, pageSize: 1000 }).then(response => {
        this.tenantList = response.data.records
      })
    },
    handleFilter() {
      this.listQuery.pageNum = 1
      this.getList()
    },
    handleTenantChange(tenantId) {
      // 清空部门选择
      this.temp.departmentId = undefined
      this.departmentList = []

      // 加载该租户的部门列表
      if (tenantId) {
        listDepartments({ tenantId }).then(response => {
          this.departmentList = response.data || []
        })
      }
    },
    resetTemp() {
      this.temp = {
        tenantId: undefined,
        departmentId: undefined,
        loginCode: '',
        agentName: '',
        displayName: '',
        email: '',
        phone: '',
        role: 'agent',
        maxConcurrent: 5
      }
    },
    handleCreate() {
      this.resetTemp()
      this.departmentList = [] // 清空部门列表
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    createData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          createAgent(this.temp).then(() => {
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '创建成功',
              type: 'success',
              duration: 2000
            })
            this.getList()
          })
        }
      })
    },
    handleUpdate(row) {
      this.temp = Object.assign({}, row)
      this.dialogStatus = 'update'
      this.dialogFormVisible = true

      // 加载该租户的部门列表
      if (row.tenantId) {
        listDepartments({ tenantId: row.tenantId }).then(response => {
          this.departmentList = response.data || []
        })
      }

      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const data = {
            departmentId: this.temp.departmentId,
            agentNo: this.temp.agentNo,
            loginCode: this.temp.loginCode,
            agentName: this.temp.agentName,
            displayName: this.temp.displayName,
            avatarUrl: this.temp.avatarUrl,
            email: this.temp.email,
            phone: this.temp.phone,
            role: this.temp.role,
            weight: this.temp.weight,
            maxConcurrent: this.temp.maxConcurrent,
            businessKeys: this.temp.businessKeys,
            welcomeMessage: this.temp.welcomeMessage,
            signature: this.temp.signature
          }
          updateAgent(this.temp.agentId, data).then(() => {
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '更新成功',
              type: 'success',
              duration: 2000
            })
            this.getList()
          })
        }
      })
    },
    handleDelete(row) {
      this.$confirm('确定删除该客服吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteAgent(row.agentId).then(() => {
          this.$notify({
            title: '成功',
            message: '删除成功',
            type: 'success',
            duration: 2000
          })
          this.getList()
        })
      })
    },
    handleResetPassword(row) {
      this.$confirm('确定重置该客服密码吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        resetAgentPassword(row.agentId).then(response => {
          this.$alert('新密码: ' + response.data, '密码重置成功', {
            confirmButtonText: '确定'
          }).then(() => {
            // 刷新列表以显示新密码
            this.getList()
          })
        })
      })
    }
  }
}
</script>

<style scoped>
.filter-container {
  margin-bottom: 20px;
}
.filter-item {
  margin-right: 10px;
}
</style>
